// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"80f4e04c","554":"a5fea793","700":"8f4ff642","717":"654c4b21","914":"d663a3d8"}[chunkId] + ".chunk.css";
};